import { render, staticRenderFns } from "./SelectBadgeColor.vue?vue&type=template&id=2f29009e"
import script from "./SelectBadgeColor.vue?vue&type=script&lang=js"
export * from "./SelectBadgeColor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports